var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._l(_vm.componentsData, function(item, index) {
        return _c(
          "div",
          { key: index, staticClass: "list-group-item" },
          [
            _c(_vm.componentMap[_vm.terminal - 1].get(item.type), {
              tag: "component",
              attrs: {
                componentContent: item.componentContent,
                terminal: _vm.terminal,
                typeId: _vm.typeId,
                shopId: _vm.shopId
              }
            })
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("loading-toast", { ref: "loadingToast" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-85b972c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-85b972c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/canvasShowPage.vue
// module id = null
// module chunks = 